import React from 'react';
// Import Global Components
import RegisterForm from '../RegisterForm';

export default function({ user, updateFormError, registerUser, ...props }) {
  return <RegisterForm
    email={user.email}
    title="Register"
    onClick={registerUser}
    btnText="Submit"
    {...props}
  />;
};
